import React, {Component} from 'react';
import UserAttributesCell from "./RedirectUrisCell";
import {PropTypes} from 'prop-types';
import * as messageConstants from '../../../shared/messages';

class RedirectUrisRow extends Component {

  static propTypes = {
    redirectUri: PropTypes.any,
    onOidcRedirectUrisUpdate: PropTypes.func,
    onRowDel: PropTypes.func,
    rowIndex: PropTypes.any,
    allowDelete: PropTypes.any,
  }
  handleOnOidcRedirectUrisUpdate = (e) => {
    this.props.onOidcRedirectUrisUpdate(e);
  }

  onDelEvent() {
    this.props.onRowDel(this.props.oidcRedirectUri);
  }

  render() {
    return (
        <tr>
          <td className="pb-12">
            <UserAttributesCell
                className="redirect-uri-input form-control attributes-input"
                onOidcRedirectUrisUpdate={this.handleOnOidcRedirectUrisUpdate}
                cellData={{
                  type: "redirectUri",
                  value: this.props.oidcRedirectUri.redirectUri,
                  id: this.props.id,
                  placeholder: messageConstants.OIDC_URI_PLACEHOLDER
                }}/>
          </td>
          {this.props.allowDelete ?
          (<td className="pl-12">
            <div className="remove-attribute-col">
              <button type="button" onClick={this.onDelEvent.bind(this)}
                      className="attr-button dell-button">
                <span className="fa fa-minus btn-circle btn-minus"/>
                <span
                    className="attr-button-label">{messageConstants.OIDC_REMOVE_URI}
                </span>
              </button>
            </div>
          </td>) : null}
        </tr>
    );

  }

}

export default RedirectUrisRow;


// WEBPACK FOOTER //
// ./src/components/OidcApp/RedirectUris/RedirectUrisRow.js